import { useQuery } from 'react-query'

import { IFilter } from 'src/components/filter/types/filter.types'

import { QUERY_KEYS } from 'src/constants'
import { removeDefaultParams } from 'src/common/utils'

import { rewardActivityService } from 'src/services/reward-activity.service'

export const initialRewardActivitiesFilter = {
  query: '',
  status: ['all'],
  type: ['all'],
  challenges: ['all'],
}

export const useGetRewardActivities = (filter?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.REWARD_ACTIVITY, filter ?? initialRewardActivitiesFilter],
    () =>
      rewardActivityService.getRewardActivity(
        removeDefaultParams(filter ?? {}, initialRewardActivitiesFilter),
      ),
    { keepPreviousData: true },
  )
}
